import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'app/shared/shared.module';
import { PosGraduacaoComponent } from './pos-graduacao.component';
import { PosGraduacaoRouter } from './pos-graduacao.router';
import { EspecializacaoModule } from './especializacao/especializacao.module';
import { PosMedModule } from './pos-med/pos-med.module';
import { MestradoModule } from './mestrado/mestrado.module';
import { DoutoradoModule } from './doutorado/doutorado.module';
import { PosModule } from './pos-graduacao/pos.module';
import { AcompanhamentoModule } from './acompanhamento/acompanhamento.module';
import { InscricaoModule } from './inscricao/inscricao.module';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PosGraduacaoRouter,
    EspecializacaoModule,
    PosMedModule,
    MestradoModule,
    DoutoradoModule,
    PosModule,
    AcompanhamentoModule,
    InscricaoModule,
  ],
  providers: [
    PessoaService,
  ],
  declarations: [
    PosGraduacaoComponent
  ],
  exports: [
    PosGraduacaoComponent,
  ],
})
export class PosGraduacaoModule {}
